import { Star, StarHalf } from 'lucide-react'

interface StarRatingProps {
    rating: number
    maxStars?: number
    size?: number
    readOnly?: boolean
    onChange?: (rating: number) => void
}

export default function StarRating({ rating, maxStars = 5, size = 16, readOnly = true, onChange }: StarRatingProps) {
    const stars = []

    for (let i = 1; i <= maxStars; i++) {
        const isFilled = i <= rating
        const isHalf = !isFilled && i - 0.5 <= rating

        stars.push(
            <button
                key={i}
                type="button"
                disabled={readOnly}
                onClick={() => onChange && onChange(i)}
                className={`${readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition-transform`}
            >
                {isFilled ? (
                    <Star size={size} className="fill-yellow-400 text-yellow-400" />
                ) : isHalf ? (
                    <StarHalf size={size} className="fill-yellow-400 text-yellow-400" />
                ) : (
                    <Star size={size} className="text-gray-300" />
                )}
            </button>
        )
    }

    return (
        <div className="flex items-center gap-0.5">
            {stars}
        </div>
    )
}
